import Icon from '../components/Icon.vue'

Icon.register({"frown":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 176C345.7 176 360 190.3 360 208S345.7 240 328 240 296 225.7 296 208 310.3 176 328 176zM168 176C185.7 176 200 190.3 200 208S185.7 240 168 240 136 225.7 136 208 150.3 176 168 176zM360.7 396.3C357.7 398.8 354.1 400 350.5 400 345.9 400 341.4 398 338.2 394.2 315.8 367.4 282.9 352 248 352S180.2 367.4 157.8 394.2C152.2 401 142.1 401.9 135.3 396.2 128.5 390.5 127.6 380.5 133.3 373.7 161.7 339.6 203.6 320 248 320S334.3 339.6 362.7 373.8C368.4 380.5 367.5 390.6 360.7 396.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/frown.js
// module id = null
// module chunks = 